import type { Prototype } from "../prototype-types";

export const riyaPathakPrototypes: Prototype[] = [
  {
    id: "rp-auto-switch-to-terms",
    name: "Choose when to pay",
    path: "/rp/auto-switch-to-terms",
    description:
      'Companion to "Direction doc: Auto-switch to terms". Checkout payment-option states for deciding between Route A (auto-switch back) and Route B (prompt to switch).',
    owner: "Riya Pathak",
    createdAt: "2026-08-06",
    lastUpdated: "2026-08-06",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/067444c12f03a43011c6eb5e785b4a9629ff88416049cee0bd7bcf3f06d04673.png",
    creationTool: "claude-code",
  },
  {
    id: "rp-net-terms-upsell",
    name: "Net terms upsell at checkout",
    path: "/rp/net-terms-upsell",
    description: "One combined inline treatment for prompting a returning retailer saved on Pay on Shipment, who has net terms available, to consider terms at checkout — with three terms-row copy variants.",
    owner: "Riya Pathak",
    createdAt: "2026-08-14",
    lastUpdated: "2026-08-14",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/28e705c1e0338a1d8d671371f0d104eabcc94df9614593a9c242e22dc12e8ed1.png",
    creationTool: "claude-code",
  }
];
